import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListPolicyOverview } from '../components/list-policy-overview';

const PolicyOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full relative md:-left-2 pt-8 bg-white py-6 px-8 border-b border-[#EAECF0]">
        <span className="text-2xl font-semibold">
          {t('menu_policy_overview')}
        </span>
      </div>
      <div className="flex-grow overflow-auto p-4">
        <ListPolicyOverview />
      </div>
    </>
  );
};

export default PolicyOverviewPage;
